<template>
  <div class="badge__wrap">
    <template v-for="badge in badges">
      <div
        :key="badge.id"
        class="badge"
        :class="[
          'badge--' + badge.template,
          { 'badge--img-only':  !badge.show_text && badge.image }
        ]"
        @click="openBadgeModal(badge)"
        v-if="isDateValid(badge)"
        :style="{
          backgroundColor: getBadgeStyle(badge, 'background_color'),
          color: getBadgeStyle(badge, 'text_color'),
          borderColor: getBadgeStyle(badge, 'border_color')
        }"
      >
        <div v-if="badge.text && badge.show_text" class="badge__text" v-html="badge.text"></div>
        <img
          v-if="badge.image && badge.image.desktop && badge.image.mobile"
          class="badge__image"
          :src="isDesktop ? badge.image.desktop : badge.image.mobile"
          alt=""
        >
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'Badge',
  data () {
    return {
      isDesktop: false
    }
  },
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    priceOnly: {
      type: Boolean,
      default: false
    },
    initialData: {
      type: [Array, String],
      default: () => []
    }
  },
  computed: {
    badges () {
      let badgesData = []

      if (Array.isArray(this.initialData)) {
        badgesData = this.initialData
      } else if (this.initialData) {
        const parsedBadges = JSON.parse(this.initialData)
        badgesData = Array.isArray(parsedBadges) ? parsedBadges : []
      }

      if (this.priceOnly) {
        return badgesData.filter(el => el.template === 'price')
      } else {
        return badgesData.filter(el => el.template !== 'price')
      }
    }
  },
  methods: {
    openBadgeModal (badge) {
      if (badge.template === 'circle') {
        this.$modal.show('result-modal', {
          type: 'badge-review',
          // title: this.$t('badge-review.modal-title'),
          subtitle: badge.description || '',
          linkText: badge.button && badge.button.text ? badge.button.text : '',
          link: badge.button && badge.button.link ? badge.button.link : ''
        })
      }
    },
    getBadgeStyle (badge, field) {
      return badge.style && badge.style[field] ? badge.style[field] : 'transparent'
    },
    isDateValid (badge) {
      if (!badge.start_date || !badge.end_date) {
        return true
      }
      const dateFromBadgeStart = new Date(badge.start_date.replace(' ', 'T'))
      const dateFromBadgeEnd = new Date(badge.end_date.replace(' ', 'T'))
      const now = new Date()
      return now > dateFromBadgeStart && now < dateFromBadgeEnd
    },
    checkIsDesktop () {
      this.isDesktop = window.innerWidth > 1024
    }
  },
  mounted () {
    this.checkIsDesktop()
    window.addEventListener('resize', this.checkIsDesktop)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkIsDesktop)
  }
}
</script>

<style lang="sass">
.photo-gallery .badge__wrap
  padding-top: 15px
  padding-left: 15px
.product-price .badge__wrap, .product-price .badge__wrap
  position: static !important
  width: auto !important
  height: auto !important
  left: unset !important
  top: unset !important
.product-card-photo .badge--circle
  width: 70px !important
  height: 70px !important
  right: 0 !important
  bottom: -27px !important
  +mmax($tablet)
    width: 50px !important
    height: 50px !important
    bottom: -15px !important
</style>
<style lang="sass" scoped="">
.badge
  &__wrap
    display: flex
    flex-direction: column
    align-items: flex-start
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    pointer-events: none

  &--stripe
    text-transform: uppercase
    padding: 3px 10px
    border-radius: 30px
    border: 1px solid transparent
    margin-bottom: 5px
    display: flex
    align-items: center
    position: relative
    z-index: 3
    pointer-events: none
    gap: 4px
    font-size: 0

    +mmax($tablet--hor)
      padding: 2px 5px

    .badge__text
      font-weight: 500
      font-size: 14px
      line-height: 18px

      +mmax($tablet--hor)
        font-weight: 400
        font-size: 10px
        line-height: 15px

    .badge__image
      height: 15px
      flex-shrink: 0
      margin-bottom: 2px
      display: block
    &.badge--img-only
      padding: 3px 0 !important
      +mmax($tablet--hor)
        padding: 2px 0 !important

  &--price
    font-size: 12px
    line-height: 15px
    padding: 2px 6px
    border-radius: 30px

    +mmin($tablet)
      font-size: 14px
      line-height: 18px

  &--circle
    position: absolute
    right: 25px
    bottom: 20px
    width: 80px
    height: 80px
    font-size: 0
    z-index: 3
    cursor: pointer
    pointer-events: auto

    +mmax(1200)
      right: 20px
      bottom: 20px
      width: 70px
      height: 70px
    .badge__image
      width: 100%
      height: 100%
</style>
